// export const initBrowserSessionGuard = () => {
//   const isReload = sessionStorage.getItem("tab_alive");

//   if (!isReload) {
//     // Fresh tab open (not a reload)
//     const openTabs = parseInt(localStorage.getItem("open_tabs") || "0");
//     if (openTabs === 0) localStorage.clear();
//     localStorage.setItem("open_tabs", String(openTabs + 1));
//   }

//   sessionStorage.setItem("tab_alive", "true"); // persists across reloads, cleared on tab close

//   window.addEventListener("beforeunload", () => {
//     if (!sessionStorage.getItem("tab_alive")) return; // safety check
//     const tabs = parseInt(localStorage.getItem("open_tabs") || "1");
//     localStorage.setItem("open_tabs", String(Math.max(0, tabs - 1)));
//   });
// };

const clearAllStorages = () => {
  localStorage.clear();
  sessionStorage.clear();

  // Clear all cookies
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    // Also clear for current domain and subdomains
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`;
  });
};

export const initBrowserSessionGuard = () => {
  const isReload = sessionStorage.getItem("tab_alive");

  if (!isReload) {
    // Fresh tab open (not a reload)
    const openTabs = parseInt(localStorage.getItem("open_tabs") || "0");
    if (openTabs === 0) clearAllStorages();
    localStorage.setItem("open_tabs", String(openTabs + 1));
  }

  sessionStorage.setItem("tab_alive", "true");

  window.addEventListener("beforeunload", () => {
    if (!sessionStorage.getItem("tab_alive")) return;
    const tabs = parseInt(localStorage.getItem("open_tabs") || "1");
    localStorage.setItem("open_tabs", String(Math.max(0, tabs - 1)));
  });
};

// const TAB_ALIVE_KEY = "tab_alive";
// const LAST_HEARTBEAT_KEY = "sp_last_heartbeat";
// const HEARTBEAT_INTERVAL_MS = 1500;
// // If the last heartbeat is more recent than this, we treat it as "another tab is currently open".
// const STALE_THRESHOLD_MS = 4000;

// const clearAllStorages = () => {
//   localStorage.clear();
//   sessionStorage.clear();

//   document.cookie.split(";").forEach((cookie) => {
//     const eqPos = cookie.indexOf("=");
//     const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
//     document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
//     document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
//     document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`;
//   });
// };

// export const initBrowserSessionGuard = () => {
//   const isSameTabReload = sessionStorage.getItem(TAB_ALIVE_KEY);

//   if (!isSameTabReload) {
//     // This tab has no memory of itself, so it's either:
//     // (a) a brand new tab opened in an existing browser session (Ctrl+click, new tab), or
//     // (b) the first tab of a genuinely new browser session.
//     // We distinguish the two by checking whether any tab has proven itself alive recently.
//     const lastHeartbeat = parseInt(
//       localStorage.getItem(LAST_HEARTBEAT_KEY) || "0",
//       10,
//     );
//     const isAnotherTabCurrentlyAlive =
//       lastHeartbeat > 0 && Date.now() - lastHeartbeat < STALE_THRESHOLD_MS;

//     if (!isAnotherTabCurrentlyAlive) {
//       // No recent proof of life from any tab -> the browser was fully closed
//       // and this is the first tab of a new session.
//       clearAllStorages();
//     }
//     // else: another tab is alive right now -> this is a duplicate/new tab in the
//     // same browser session, so we deliberately do nothing destructive here.
//     // It will simply read whatever redux-persist/localStorage already has.
//   }

//   sessionStorage.setItem(TAB_ALIVE_KEY, "true");

//   // Prove this tab is alive, repeatedly, for as long as it's open.
//   // No reliance on beforeunload/unload firing correctly (they don't, reliably).
//   const heartbeat = () =>
//     localStorage.setItem(LAST_HEARTBEAT_KEY, String(Date.now()));
//   heartbeat();
//   const intervalId = window.setInterval(heartbeat, HEARTBEAT_INTERVAL_MS);

//   // Best-effort cleanup; not load-bearing for correctness since staleness
//   // is what actually drives the decision above.
//   window.addEventListener("pagehide", () => {
//     window.clearInterval(intervalId);
//   });
// };
